<div class="page-center-wrapper">
    <div class="card">
        <div class="row justify-content-center align-items-center"
            style="margin-right: 0px !important; margin-left: 0px !important;">
            <div class="col-sm-12 col-md-12 title_header_bar d-flex justify-content-center align-items-center">
                <button class="btn btn-link" type="button" (click)="goBack()"
                    title="Back to Manage Relocation Promotion" style="position: absolute; left: 8px;">
                    <i class="fa fa-arrow-left fa-lg" style="color: #ffffff; font-size: 1.80em;"></i>
                </button>
                <span>Relocation Retention Promotion</span>
            </div>
        </div>
        <div class="row justify-content-center align-item-center">
            <div class="col-sm-12 col-md-12">
                <form [formGroup]="form" (ngSubmit)="generateLink()">
                    <div class="row d-felx justify-content-center" style="margin: 40px;">
                        <div class="col-sm-12 col-md-9  mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Customer Number</mat-label>
                                <input matInput formControlName="customerNumber" placeholder="Enter Customer Number"
                                    class="col-10" autocomplete="off" (keydown.space)="$event.preventDefault()">
                            </mat-form-field>
                            <mat-error
                                *ngIf="!form.get('customerNumber').valid && (form.get('customerNumber').dirty || form.get('customerNumber').touched)">
                                Customer Number is required
                            </mat-error>
                        </div>
                    </div>
                </form>
                <div class="d-flex justify-content-center button-style mt-3 mb-3">
                    <button class="btn btn-secondary mb-3" type="button" (click)="generateLink()" matButton>
                        Submit</button>
                </div>
            </div>
        </div>
    </div>
</div>